import React from "react";
import "./Dashboard.css";
import DashboardHeader from "../../components/DashBoardHeader/DashboardHeader";
import DashboardContent from "../../components/DashBoardContent/DashboardContent";
import DashboardSideBar from "../../components/DashboardSideBar/DashboardSideBar";
import { Outlet } from "react-router-dom";

export default function DashBoard() {
  return (
    <main className="dashboard">
      <DashboardHeader />
      <DashboardContent>
        <Outlet />
      </DashboardContent>
      <DashboardSideBar />
    </main>
  );
}
